import { ElementType, ReactNode } from 'react';
import { TextPresetKey } from '@optimus-web/local-tokens';
import { Ellipticable } from './helpers';

export interface TypographyOptions {
    align?: 'left' | 'right' | 'center';
    noWrap?: boolean;
    overflowWrap?: 'normal' | 'break-word';
    wordBreak?: 'break-all' | 'break-word' | 'normal';
}

export interface Secondary {
    secondary?: boolean;
}

export interface Inverse {
    inverse?: boolean;
}

export interface TypographyProps extends TypographyOptions, Secondary, Ellipticable, Inverse {
    preset: TextPresetKey;
    as?: ElementType;
    children?: ReactNode;
}

export type CaptionProps = Omit<TypographyProps, 'preset'>;
